import { TypeMetadata } from './TypeMetadata';
var TypeCache = /** @class */ (function () {
    function TypeCache(schema) {
        this.schema = schema;
        this._objects = {};
        this._root = new TypeMetadata();
        this._root.parse(schema, this);
    }
    Object.defineProperty(TypeCache.prototype, "root", {
        get: function () {
            return this._root;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TypeCache.prototype, "objects", {
        get: function () {
            return this._objects;
        },
        enumerable: false,
        configurable: true
    });
    // This is an internal method used by TypeMetadata
    TypeCache.prototype.getOrAddType = function (name) {
        if (name.startsWith("#/definitions/")) {
            name = name.replace("#/definitions/", "");
            var type = this._objects[name];
            if (!type) {
                // Look for this type in the definitions
                type = new TypeMetadata();
                this._objects[name] = type;
                type.parse(this.schema.definitions[name], this);
                if (type.customType) {
                    type.customType.name = name;
                }
            }
            return type;
        }
        else {
            throw Error("Unknown type name.");
        }
    };
    return TypeCache;
}());
export { TypeCache };
